import { CSSProperties } from 'react';
import { theme } from '../../theme';

export const installmentSelectorStyles = {
  fieldset: {
    border: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.extraSmall,
  } as CSSProperties,

  legend: {
    marginBottom: theme.spacing.medium,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.bold,
    lineHeight: theme.typography.lineHeight.lg,
    color: theme.colors.label,
    padding: 0,
  } as CSSProperties,

  statusText: {
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.placeholder,
    fontFamily: theme.typography.fontFamily,
    margin: 0,
    lineHeight: theme.typography.lineHeight.md,
  } as CSSProperties,

  errorText: {
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.error,
    fontFamily: theme.typography.fontFamily,
    margin: 0,
    lineHeight: theme.typography.lineHeight.md,
  } as CSSProperties,
};
